import { useState, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getFieldMapping, saveFieldMapping } from '@modules/offers/services/api';
import type { PlaybookSection } from '../types';

const useFieldMapping = (section: PlaybookSection) => {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ['field-mapping', section],
    queryFn: () => getFieldMapping(),
    staleTime: 5 * 60 * 1000,
  });

  const [mappingJson, setMappingJson] = useState<Record<string, any>>({});
  const [webhookUrl, setWebhookUrl] = useState('');
  const [prodWebhookUrl, setProsWebhookUrl] = useState('');

  useEffect(() => {
    if (query.data?.data?.response) {
      setMappingJson(query.data.data.response);
    }
    if (query.data?.data?.webhookUrl) {
      setWebhookUrl(query.data.data.webhookUrl);
    }
    if (query.data?.data?.prodWebhookUrl) {
      setProsWebhookUrl(query.data.data.prodWebhookUrl);
    }
  }, [query.data]);

  const mutation = useMutation({
    mutationFn: async (payload: Record<string, any>) => saveFieldMapping(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['field-mapping'] });
    },
  });

  return {
    ...query,
    mappingJson,
    setMappingJson,
    webhookUrl,
    setWebhookUrl,
    prodWebhookUrl,
    setProsWebhookUrl,
    saveMapping: mutation.mutateAsync,
    saving: mutation.isPending,
  };
};

export default useFieldMapping;
